import { ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'

import { Invoice } from '@features/invoicesLegacy/types/invoice'
import { PaymentReconciliationModalWrapper } from '@features/paymentReconciliationModal'
import { SubjectReconciliationModalInner } from '@features/paymentReconciliationModal/elements/SubjectReconciliationModalInner'
import { useSubjectReconciliationSuggestions } from '@features/paymentReconciliationModal/hooks'

import { useFetchInvoicesForPaymentReconciliation } from './hooks/useFetchInvoicesForPaymentReconciliation'

export interface InvoiceReconciliationModalProps extends ModalProps {
  subject: Invoice
  isCashBasis?: boolean
}

export const InvoiceReconciliationModal = ({
  subject,
  isCashBasis = false,
  ...modalProps
}: InvoiceReconciliationModalProps): ReactElement => {
  const { invoices, isLoading } = useFetchInvoicesForPaymentReconciliation(subject)
  const { suggestions } = useSubjectReconciliationSuggestions(subject)

  return (
    <PaymentReconciliationModalWrapper<Invoice>
      id={modalProps.id}
      currentSubject={subject as Invoice}
      isLoading={isLoading}
      subjects={invoices}
      suggestions={suggestions}
      isCashBasis={isCashBasis}
    >
      <SubjectReconciliationModalInner {...modalProps} subject={subject} />
    </PaymentReconciliationModalWrapper>
  )
}
